<template>
  <div class="dashboard-header">
    <h2><slot>Dashboard</slot></h2>
  </div>
</template>

<script>
export default {
  name: 'DashboardHeader',
}
</script>

<style scoped lang="scss">
.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: linear-gradient(90deg, #2B3A42 0%, #4F8A8B 100%);
  border-radius: 12px;
  padding: 18px 32px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
}
.dashboard-header h2 {
  color: #fff;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 1px;
  text-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
}
</style>
